/* Jane Lushka v1.2 footer (phase 6, F9): phone accordions of snippets/jl-footer-v12.liquid.
   One delegated click handler on .jl-ft__toggle (a real <button>, so Enter and Space work natively): it flips the
   button's aria-expanded and the column's data-open. CSS shows the panels: below 768 a column without data-open hides
   its list (html.js only); from 768 the buttons are hidden and every list shows. No work on load, so nothing shifts
   when this file arrives. Loaded with defer by sections/footer.liquid in the v1.2 layout (instead of collapsible.js and
   footer.js). The flag keeps one handler when the theme editor re-renders the footer and runs the script again.
   Also the homepage category scroller's keyboard focus (N5, O-HT1; moved here at INTEGRATE from an inline script in
   sections/jl-home-categories.liquid, contract G13 / P6): Chromium leaves a half-visible focused tile where it is, so one
   delegated focusin handler scrolls a focused .jl-hcat__tile fully into its list (block / inline "nearest"), only while
   the list overflows (phones; the grid from 768 never does). Smooth only when the html computes scroll-behavior smooth
   (jl-apple.css) and reduced motion is off. With the previous footer layout this file does not load and the tiles keep
   the browser's own focus scroll.
   Band states (N1): Shopify's redirect after the band's POST keeps the form's #JlNl-<id>, and the browser's fragment
   scroll runs after autofocus and leaves focus on the body. After load, the message (or the invalid field) takes focus
   again, without scrolling, unless focus has already moved somewhere else. */
(function () {
  if (window.jlFooterReady) return;
  window.jlFooterReady = true;
  function nlFocus() {
    var a = document.querySelector('.jl-nl [autofocus]');
    var f = document.activeElement;
    if (a && (!f || f === document.body)) a.focus({ preventScroll: true });
  }
  if (document.readyState === 'complete') nlFocus();
  else window.addEventListener('load', nlFocus);
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.jl-ft__toggle') : null;
    if (!t) return;
    var col = t.closest('.jl-ft__col');
    var open = t.getAttribute('aria-expanded') !== 'true';
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (col) {
      if (open) col.setAttribute('data-open', '');
      else col.removeAttribute('data-open');
    }
  });
  document.addEventListener('focusin', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.jl-hcat__tile') : null;
    var l = t && t.closest('.jl-hcat__list');
    if (!l || l.scrollWidth <= l.clientWidth) return;
    var smooth = getComputedStyle(document.documentElement).scrollBehavior === 'smooth' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: smooth ? 'smooth' : 'auto' });
  });
})();
